// Who runs this service, in the form a reader needs on a page rather than in a
// contract.
//
// The authority for every value here is the published legal text: the Terms
// name the operator and its registered address, and the same address is the one
// a notice has to be sent to. Those texts are generated from markdown into
// @doc-cheap/legal as one HTML blob, so there is nothing to import field by
// field — which is exactly how a company page ends up quietly disagreeing with
// the contract beside it. The unit test next to this file reads the published
// text and asserts every line below still appears in it.

import { OPERATOR_NAME } from "@doc-cheap/legal";

/** The operator's registered postal address, line by line. */
export const OPERATOR_ADDRESS: readonly string[] = ["Midvangur 7", "701 Egilsstaðir", "Iceland"];

/** The country the operator is established in. */
export const OPERATOR_COUNTRY = "Iceland";

/** The one address for everything: support, legal notices, privacy requests. */
export const OPERATOR_EMAIL = "admin@doc.cheap";

/** The operator's legal name, as the contracts state it. */
export { OPERATOR_NAME };
